import { memo, useCallback } from 'react'
import DateRangePickerInput from '../DateRangePickerInput'
import { DateRangePickerInputProps } from '../DateRangePickerInput/DateRangePickerInput.types'
import { DatePickerInputProps } from './DatePickerInput.types'

function DatePickerInput({ value, onChange, ...props }: DatePickerInputProps) {
  const onChangeWrapper = useCallback(
    (newValue: DateRangePickerInputProps['value']) => {
      onChange(newValue.startDate!)
    },
    [onChange],
  )
  const valueWrapper = { startDate: value ?? null, endDate: null }

  return (
    <DateRangePickerInput
      value={valueWrapper}
      onChange={onChangeWrapper}
      singleDate
      showBlankOnNull
      {...props}
    />
  )
}

export default memo(DatePickerInput)
